import React from 'react';
import { Input, Modal, Select } from 'shopee-ui-react';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { ConfigState } from '@reducers/config/type';
import { OtherCorrectType } from '@contants/index';

interface MemoModalProps {
  visible: boolean;
  correctType: number | undefined;
  correctRemark: string;
  confirm: () => void;
  correctTypeChange: (value: number) => void;
  correctRemarkChange: (value: string) => void;
  setVisible: (value: boolean) => void;
}

const MemoModal = ({
  visible = false,
  correctType = undefined,
  correctRemark = '',
  confirm,
  correctTypeChange,
  correctRemarkChange,
  setVisible,
}: MemoModalProps) => {
  const correctTypeOptions = useSelector(
    (state: { config: ConfigState }) => state.config.correctTypeOptions
  );

  return (
    <Modal
      className={styles.memo_modal}
      title="Remarks"
      visible={visible}
      confirmText="Save"
      onConfirm={() => confirm()}
      onCancel={() => setVisible(false)}>
      <Select
        value={correctType}
        onChange={value => correctTypeChange(value as number)}>
        {correctTypeOptions.map((item, index) => (
          <Select.Option
            key={index}
            value={item.code}>
            {item.displayStr}
          </Select.Option>
        ))}
      </Select>
      {correctType === OtherCorrectType ? (
        <Input
          className={styles.other_input}
          value={correctRemark}
          placeholder="Others, please specify"
          maxLength={100}
          showWordLimit
          clearable
          onChange={correctRemarkChange}
        />
      ) : null}
    </Modal>
  );
};

export default MemoModal;
